export default __webpack_public_path__ + "static/media/HTMLCircularBackground-light-sepia-200px.8eda1e83.jpg";